export default {
  mainTitle: {
    id: 'main_title',
    defaultMessage: 'Your cart',
  },
}
